require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/~/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 1057
// module chunks = 0